import { ExternalLink, AlertTriangle } from 'lucide-react';

interface ExternalPaymentModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isProcessing: boolean;
}

export function ExternalPaymentModal({ isOpen, onClose, onConfirm, isProcessing }: ExternalPaymentModalProps) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200">
            <div className="bg-white dark:bg-gray-800 rounded-2xl w-full max-w-sm overflow-hidden shadow-xl animate-in zoom-in-95 duration-200">

                {/* Header with Icon */}
                <div className="bg-orange-50 dark:bg-orange-900/20 p-6 flex flex-col items-center justify-center border-b border-orange-100 dark:border-orange-800/50">
                    <div className="w-16 h-16 bg-orange-100 dark:bg-orange-800/30 rounded-full flex items-center justify-center mb-4 text-orange-600 dark:text-orange-400">
                        <ExternalLink className="w-8 h-8" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white text-center">
                        Redirección Externa
                    </h3>
                </div>

                <div className="p-6 space-y-4">
                    <div className="flex items-start gap-3 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-xl">
                        <AlertTriangle className="w-5 h-5 text-blue-600 dark:text-blue-400 shrink-0 mt-0.5" />
                        <p className="text-sm text-blue-800 dark:text-blue-200">
                            Estás por salir de la aplicación para realizar el pago.
                        </p>
                    </div>

                    <p className="text-gray-600 dark:text-gray-300 text-center text-sm leading-relaxed">
                        Una vez finalizado el pago, <strong>no cierres la ventana externa</strong>.
                        Serás redirigido automáticamente o deberás volver aquí para ver tu confirmación.
                    </p>

                    <div className="flex flex-col gap-3 mt-6">
                        <button
                            onClick={onConfirm}
                            disabled={isProcessing}
                            className="w-full py-3.5 bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 text-white rounded-xl font-bold shadow-lg shadow-indigo-500/20 active:scale-95 transition-all flex items-center justify-center gap-2"
                        >
                            {isProcessing ? (
                                <>
                                    <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                                    <span>Procesando...</span>
                                </>
                            ) : (
                                <span>Continuar al Pago</span>
                            )}
                        </button>

                        <button
                            onClick={onClose}
                            disabled={isProcessing}
                            className="w-full py-3 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 rounded-xl font-medium border border-gray-200 dark:border-gray-600 transition-colors"
                        >
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
